import { error } from '../app/logger.js';
import { locations } from '../data/locations.js';
import { SwapMarker } from '../map/swap_marker.js';
import { listenToEvent } from '../util/listen_to_event.js';
import { LocViewBase } from './loc_view_base.js';

class LocViewFull extends LocViewBase {
  static markupType = 'full';
  static tagName = 'loc-view-full';

  static get elements() {
    const s = this.selectors;
    return {
      locDataContainer: s.LocDataContainer,
      mapControlsBarElement: this.selectors.MapControlsBar,
      mapHolderElement: s.MapHolder,
    };
  }

  initialize() {
    super.initialize();

    listenToEvent(this.mapControlsBarElement, 'enlarge', () =>
      this.openRelatedLoc(this.loc)
    );
  }

  setup(map) {
    this.release();
    this.#map = map;

    if (!this.loc) {
      this.loc = this.#getLocFromMarkup();
    }

    // Adopt the map.
    this.mapControlsBarElement.map = this.#map;

    this.swapMarker = new SwapMarker(map, {
      name: 'locpanel-swapmarker',
    });

    this.#map.locs.on_marker_click = loc => this.openRelatedLoc(loc);
    this.#map.locs.on_marker_dblclick = () => {
      // nothing to do
    };

    this.#trackActiveListener = this.#map.on('trackactive', ev => {
      if (ev.track && ev.track.loc) {
        this.openRelatedLoc(ev.track.loc);
      }
    });
  }

  release() {
    if (!this.#map) {
      return;
    }

    this.swapMarker.release();
    this.swapMarker = null;
    this.mapControlsBarElement.map = null;
    this.#map.locs.on_marker_click = () => {};
    this.#map.off('trackactive', this.#trackActiveListener);
    this.#map = null;
  }

  openRelatedLoc(loc) {
    this.swapMarker.release();
    this.dispatchEvent(
      new CustomEvent('fullmapswitch', {
        detail: loc,
      })
    );
  }

  #getLocFromMarkup() {
    let datastr = this.locDataContainer.innerHTML;
    if (datastr) {
      try {
        const locData = JSON.parse(datastr);
        return locations.from(locData);
      } catch (e) {
        error(`[locview] failed to parse location data, got '${datastr}'`, e);
      }
    }
    return null;
  }

  #map;
  #trackActiveListener;
}

LocViewFull.defineCustomElement();

export { LocViewFull };
